import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../config/environments';

export default function PaymentSuccess() {
  console.log("PAYMENT SUCCESS URL:", window.location.href);
  const [loading, setLoading] = useState(true);
  const [verified, setVerified] = useState(false);
  const [orderId, setOrderId] = useState(null);
  const [countdown, setCountdown] = useState(15);
  const [responseData, setResponseData] = useState(null);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const id = params.get('orderId');
    const token = params.get('token');
    setOrderId(id);

    if (!id || !token) {
      setVerified(false);
      setLoading(false);
      return;
    }

    const apiUrl = `${BASE_URL}/justpay/v1/order/${id}`;

    fetch(apiUrl, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then(async (res) => {
        if (!res.ok) {
          throw new Error(`Server error: ${res.status}`);
        }

        return res.json();
      })
      .then((data) => {
        const isVerified = data?.status === 'CHARGED';

        setVerified(isVerified);
        setResponseData(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error('Error verifying order:', err);

        setVerified(false);
        setResponseData(null);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    if (loading) {
      return;
    }

    const countdownInterval = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(countdownInterval);

          setShowDetails(true);

          const redirectUrl =
            responseData?.redirectUrl || '/';
            window.location.href = redirectUrl;

          return 0;
        }

        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(countdownInterval);
  }, [loading, responseData]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 p-8">
      <div className="bg-white shadow-xl rounded-xl p-6 text-center w-full max-w-sm">

        {loading ? (
          <div className="text-blue-500 text-lg font-medium">
            Verifying Card for Order ID {orderId}...

            <p>
              Please do not refresh or close this window
            </p>
          </div>

        ) : verified ? (
          <>
            <div className="text-green-600 text-5xl mb-4">
              ✅
            </div>

            <h1 className="text-2xl font-bold mb-2">
              Credit Card Verified Successfully
            </h1>

            <p>
              Please add the chosen hotel to your itinerary
            </p>

            <p className="text-gray-700 mb-2">
              Redirecting in {countdown} seconds...
              Please do not refresh or close this window
            </p>
          </>

        ) : (
          <>
            <div className="text-red-600 text-5xl mb-4">
              ❌
            </div>

            <h1 className="text-2xl font-bold mb-2">
              Credit Card Verification Failed
            </h1>

            <p>
              Please verify & re-enter the credit card details
              or provide an alternate card to proceed with your booking
            </p>

            <p className="text-gray-700 mb-2">
              Redirecting in {countdown} seconds...
            </p>

            <p>
              Please do not refresh or close this window
            </p>
          </>
        )}

      </div>
    </div>
  );
}
